import type {
  AssetPayload,
  BaseEventSchema,
  GeotagSchema,
} from "@phc/common/gen/preferencesGen"
export type Asset = AssetPayload
export type AssetInput = AssetPayload

const toGeotagInput = (geotag: GeotagSchema): GeotagSchema => ({
  location_id: geotag.location_id,
  wkt_centroid: geotag.wkt_centroid ?? undefined,
  mapbox_location: geotag.mapbox_location ?? undefined,
})

const toBaseEventInput = (
  baseEvent?: BaseEventSchema | null
): BaseEventSchema | undefined => {
  if (!baseEvent) return undefined

  return {
    geotags: baseEvent.geotags.map(toGeotagInput),
  }
}

export const toAssetInput = (asset?: Asset): AssetInput => {
  if (!asset) return {}

  return {
    asset_id: asset.asset_id ?? undefined,
    name: asset.name ?? undefined,
    notes: asset.notes ?? undefined,
    threat_radius: asset.threat_radius ?? undefined,
    industry: asset.industry ?? undefined,
    asset_groups: asset.asset_groups ?? undefined,
    asset_types: asset.asset_types ?? undefined,
    notification_settings: asset.notification_settings ?? undefined,
    base_event: toBaseEventInput(asset.base_event),
  }
}
